import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import './assets/styles/main.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from '@/locals'
import pinia from './stores'
import setupSentry from '@/utils/sentry'
import { v3ImgLoad } from 'web-utils/directives'
import 'animate.css'

const app = createApp(App)
setupSentry(app)
app.directive('load', v3ImgLoad)
app.use(pinia)
app.use(router)
app.use(i18n)
app.mount('#app')
